






































































































































































import Component from 'vue-class-component';
import Vue from 'vue';
import BaseAttributeCollection from '@/classes/attributes/baseAttributeCollection';
import TalentCollection from '../../classes/attributes/talentCollection';
import { TalentField, Attributes } from '../../classes/character/allValues';
import { Checker, CheckResult } from '../../classes/character/checker';
import Character from '../../classes/character/character';
import { Prop, Watch } from 'vue-property-decorator';
import BaseAttribute from '../../classes/attributes/baseAttribute';
import { Modifier } from '../../classes/character/modifier';

@Component
export default class CheckDialog extends Vue {
  @Prop({ default: false })
  public open!: boolean;

  @Prop()
  public name!: string;

  @Prop()
  public characterId!: string;

  private character: Character | null = null;

  private previousChecks: CheckResult[] = [];
  private previousChecksModel = false;

  private loading = true;
  private currentResult: CheckResult | null = null;

  private selectedAttributes: number[] = [];
  private checkedTalent: string = '';

  private individualModifier: string = '0';

  private attributeCollection = new BaseAttributeCollection();
  private talentCollection = new TalentCollection();

  private alertModel = false;

  constructor() {
    super();
  }

  private alertChange(input) {
    if (input === false) {
      this.alertModel = false;
    }
  }

  @Watch('open')
  private watchDialogOpen(open) {
    if (!open) {
      return;
    }
    if (!this.characterId) {
      throw new Error('No characterId passed');
    }
    this.$store.dispatch('loadCharacter', this.characterId).then((data) => {
      this.character = new Character(data);
      this.loading = false;
    });
  }

  get attributes(): BaseAttribute[] {
    return this.attributeCollection.baseDiceAttributes.map((attribute) => this.getFinalValue(attribute.abbreviation));
  }

  get talentFields() {
    return this.talentCollection.getAllTalentFields();
  }

  private doCheck() {
    if (this.selectedAttributes.length === 0) {
      throw new Error('Cannot do check without dices selected');
    }

    // Collect the attributes
    const attributesToCheck: BaseAttribute[] = [];
    this.selectedAttributes.forEach((indexOfAttribute) => {
      attributesToCheck.push(this.attributes[indexOfAttribute]);
    });

    if (this.checkedTalent !== '') {
      attributesToCheck.push(this.getFinalValue(this.checkedTalent));
    }

    const result = Checker.check(attributesToCheck, parseInt(this.individualModifier, 10));
    this.currentResult = result;
    this.previousChecks.unshift(result);
    this.alertModel = true;
  }

  private checkTalent(abbreviation) {
    if (this.checkedTalent === abbreviation) {
      this.checkedTalent = '';
    } else {
      this.checkedTalent = abbreviation;
    }
  }

  private getTalentsOfField(field: TalentField) {
    return this.talentCollection.getTalentsByTalentField(field);
  }

  private getFinalValue(abbreviation: string) {
    if (this.character === null) {
      throw new Error('Character not initialized');
    }
    return this.character.getFinalValueByAbbreviation(abbreviation);
  }

  private getCharacterTalentValueString(talentAbbreviation: string) {
    if (this.character === null) {
      throw new Error('Character not initialized');
    }
    if (!this.character.hasAttribute(talentAbbreviation)) {
      return '';
    }
    const value = this.character.getFinalValueByAbbreviation(talentAbbreviation);
    return '(TW' + value.toString() + ')';
  }

  private concatAttributes(attributes: BaseAttribute[]) {
    return attributes.map((attr) => attr.name).join(' , ');
  }
}
